document.addEventListener('DOMContentLoaded', function() {
  // Register GSAP
  gsap.registerPlugin(ScrollTrigger);

  // Register autoscroll
  $('.is-scrollable[auto-scroll] > *').on('animationiteration', function() {
    const parent = $(this).parent();
    const nextSibling = $(this).next()[0];

    if (nextSibling) {
      parent.scrollLeft((left) => left += nextSibling.offsetLeft);
    } else {
      parent.scrollLeft(0);
    }
  });
});